const vsDarkTheme = {
	"$schema": "vscode://schemas/color-theme",
	"type": "dark",
	"colors": {
		"activityBarBadge.background": "#007acc",
		"editor.background": "#1e1e1e",
		"editor.foreground": "#d4d4d4",
		"editor.inactiveSelectionBackground": "#3a3d41",
		"editor.selectionHighlightBackground": "#add6ff26",
		"editorIndentGuide.activeBackground": "#707070",
		"editorIndentGuide.background": "#404040",
		"input.placeholderForeground": "#a6a6a6",
		"list.dropBackground": "#383b3d",
		"menu.background": "#252526",
		"menu.foreground": "#cccccc",
		"sideBarSectionHeader.background": "#00000000",
		"sideBarSectionHeader.border": "#cccccc33",
		"sideBarTitle.foreground": "#bbbbbb",
		"statusBarItem.remoteBackground": "#16825d",
		"statusBarItem.remoteForeground": "#ffffff",
		"tab.lastPinnedBorder": "#cccccc33",
		"activityBar.activeBorder": "#ffffff",
		"activityBar.background": "#333333",
		"activityBar.dropBorder": "#ffffff",
		"activityBar.foreground": "#ffffff",
		"activityBar.inactiveForeground": "#ffffff66",
		"activityBarBadge.foreground": "#ffffff",
		"badge.background": "#4d4d4d",
		"badge.foreground": "#ffffff",
		"breadcrumb.activeSelectionForeground": "#e0e0e0",
		"breadcrumb.background": "#1e1e1e",
		"breadcrumb.focusForeground": "#e0e0e0",
		"breadcrumb.foreground": "#cccccccc",
		"breadcrumbPicker.background": "#252526",
		"button.background": "#0e639c",
		"button.foreground": "#ffffff",
		"button.hoverBackground": "#1177bb",
		"button.secondaryBackground": "#3a3d41",
		"button.secondaryForeground": "#ffffff",
		"button.secondaryHoverBackground": "#45494e",
		"charts.blue": "#75beff",
		"charts.foreground": "#cccccc",
		"charts.green": "#89d185",
		"charts.lines": "#cccccc80",
		"charts.orange": "#d18616",
		"charts.purple": "#b180d7",
		"charts.red": "#f48771",
		"charts.yellow": "#cca700",
		"checkbox.background": "#3c3c3c",
		"checkbox.border": "#3c3c3c",
		"checkbox.foreground": "#f0f0f0",
		"debugConsole.errorForeground": "#f48771",
		"debugConsole.infoForeground": "#75beff",
		"debugConsole.sourceForeground": "#cccccc",
		"debugConsole.warningForeground": "#cca700",
		"debugConsoleInputIcon.foreground": "#cccccc",
		"debugExceptionWidget.background": "#420b0d",
		"debugExceptionWidget.border": "#a31515",
		"debugIcon.breakpointCurrentStackframeForeground": "#ffcc00",
		"debugIcon.breakpointDisabledForeground": "#848484",
		"debugIcon.breakpointForeground": "#e51400",
		"debugIcon.breakpointStackframeForeground": "#89d185",
		"debugIcon.breakpointUnverifiedForeground": "#848484",
		"debugIcon.continueForeground": "#75beff",
		"debugIcon.disconnectForeground": "#f48771",
		"debugIcon.pauseForeground": "#75beff",
		"debugIcon.restartForeground": "#89d185",
		"debugIcon.startForeground": "#89d185",
		"debugIcon.stepBackForeground": "#75beff",
		"debugIcon.stepIntoForeground": "#75beff",
		"debugIcon.stepOutForeground": "#75beff",
		"debugIcon.stepOverForeground": "#75beff",
		"debugIcon.stopForeground": "#f48771",
		"debugTokenExpression.boolean": "#4e94ce",
		"debugTokenExpression.error": "#f48771",
		"debugTokenExpression.name": "#c586c0",
		"debugTokenExpression.number": "#b5cea8",
		"debugTokenExpression.string": "#ce9178",
		"debugTokenExpression.value": "#cccccc99",
		"debugToolBar.background": "#333333",
		"debugView.exceptionLabelBackground": "#6c2022",
		"debugView.exceptionLabelForeground": "#cccccc",
		"debugView.stateLabelBackground": "#88888844",
		"debugView.stateLabelForeground": "#cccccc",
		"debugView.valueChangedHighlight": "#569cd6",
		"descriptionForeground": "#ccccccb3",
		"diffEditor.diagonalFill": "#cccccc33",
		"diffEditor.insertedTextBackground": "#9bb95533",
		"diffEditor.removedTextBackground": "#ff000033",
		"dropdown.background": "#3c3c3c",
		"dropdown.border": "#3c3c3c",
		"dropdown.foreground": "#f0f0f0",
		"editor.findMatchBackground": "#515c6a",
		"editor.findMatchHighlightBackground": "#ea5c0055",
		"editor.findRangeHighlightBackground": "#3a3d4166",
		"editor.focusedStackFrameHighlightBackground": "#7abd7a4d",
		"editor.foldBackground": "#264f784d",
		"editor.hoverHighlightBackground": "#264f7840",
		"editor.lineHighlightBorder": "#282828",
		"editor.linkedEditingBackground": "#ff00004d",
		"editor.rangeHighlightBackground": "#ffffff0b",
		"editor.selectionBackground": "#264f78",
		"editor.snippetFinalTabstopHighlightBorder": "#525252",
		"editor.snippetTabstopHighlightBackground": "#7c7c7c4d",
		"editor.stackFrameHighlightBackground": "#ffff0033",
		"editor.symbolHighlightBackground": "#ea5c0055",
		"editor.wordHighlightBackground": "#575757b8",
		"editor.wordHighlightStrongBackground": "#004972b8",
		"editorActiveLineNumber.foreground": "#c6c6c6",
		"editorBracketMatch.background": "#0064001a",
		"editorBracketMatch.border": "#888888",
		"editorCodeLens.foreground": "#999999",
		"editorCursor.foreground": "#aeafad",
		"editorError.foreground": "#f48771",
		"editorGroup.border": "#444444",
		"editorGroup.dropBackground": "#53595d80",
		"editorGroupHeader.noTabsBackground": "#1e1e1e",
		"editorGroupHeader.tabsBackground": "#252526",
		"editorGutter.addedBackground": "#587c0c",
		"editorGutter.background": "#1e1e1e",
		"editorGutter.commentRangeForeground": "#c5c5c5",
		"editorGutter.deletedBackground": "#94151b",
		"editorGutter.foldingControlForeground": "#c5c5c5",
		"editorGutter.modifiedBackground": "#0c7d9d",
		"editorHint.foreground": "#eeeeeeb3",
		"editorHoverWidget.background": "#252526",
		"editorHoverWidget.border": "#454545",
		"editorHoverWidget.foreground": "#cccccc",
		"editorHoverWidget.statusBarBackground": "#2c2c2d",
		"editorInfo.foreground": "#75beff",
		"editorLightBulb.foreground": "#ffcc00",
		"editorLightBulbAutoFix.foreground": "#75beff",
		"editorLineNumber.activeForeground": "#c6c6c6",
		"editorLineNumber.foreground": "#858585",
		"editorLink.activeForeground": "#4e94ce",
		"editorMarkerNavigation.background": "#2d2d30",
		"editorMarkerNavigationError.background": "#f48771",
		"editorMarkerNavigationInfo.background": "#75beff",
		"editorMarkerNavigationWarning.background": "#cca700",
		"editorOverviewRuler.addedForeground": "#587c0c99",
		"editorOverviewRuler.border": "#7f7f7f4d",
		"editorOverviewRuler.bracketMatchForeground": "#a0a0a0",
		"editorOverviewRuler.commonContentForeground": "#60606066",
		"editorOverviewRuler.currentContentForeground": "#40c8ae80",
		"editorOverviewRuler.deletedForeground": "#94151b99",
		"editorOverviewRuler.errorForeground": "#ff1212b3",
		"editorOverviewRuler.findMatchForeground": "#d186167e",
		"editorOverviewRuler.incomingContentForeground": "#40a6ff80",
		"editorOverviewRuler.infoForeground": "#75beff",
		"editorOverviewRuler.modifiedForeground": "#0c7d9d99",
		"editorOverviewRuler.rangeHighlightForeground": "#007acc99",
		"editorOverviewRuler.selectionHighlightForeground": "#a0a0a0cc",
		"editorOverviewRuler.warningForeground": "#cca700",
		"editorOverviewRuler.wordHighlightForeground": "#a0a0a0cc",
		"editorOverviewRuler.wordHighlightStrongForeground": "#c0a0c0cc",
		"editorPane.background": "#1e1e1e",
		"editorRuler.foreground": "#5a5a5a",
		"editorSuggestWidget.background": "#252526",
		"editorSuggestWidget.border": "#454545",
		"editorSuggestWidget.foreground": "#d4d4d4",
		"editorSuggestWidget.highlightForeground": "#0097fb",
		"editorSuggestWidget.selectedBackground": "#062f4a",
		"editorUnnecessaryCode.opacity": "#000000aa",
		"editorWarning.foreground": "#cca700",
		"editorWhitespace.foreground": "#e3e4e229",
		"editorWidget.background": "#252526",
		"editorWidget.border": "#454545",
		"editorWidget.foreground": "#cccccc",
		"errorForeground": "#f48771",
		"extensionBadge.remoteBackground": "#007acc",
		"extensionBadge.remoteForeground": "#ffffff",
		"extensionButton.prominentBackground": "#0e639c",
		"extensionButton.prominentForeground": "#ffffff",
		"extensionButton.prominentHoverBackground": "#1177bb",
		"focusBorder": "#007fd4",
		"foreground": "#cccccc",
		"gitDecoration.addedResourceForeground": "#81b88b",
		"gitDecoration.conflictingResourceForeground": "#6c6cc4",
		"gitDecoration.deletedResourceForeground": "#c74e39",
		"gitDecoration.ignoredResourceForeground": "#8c8c8c",
		"gitDecoration.modifiedResourceForeground": "#e2c08d",
		"gitDecoration.stageDeletedResourceForeground": "#c74e39",
		"gitDecoration.stageModifiedResourceForeground": "#e2c08d",
		"gitDecoration.submoduleResourceForeground": "#8db9e2",
		"gitDecoration.untrackedResourceForeground": "#73c991",
		"gitlens.gutterBackgroundColor": "#ffffff13",
		"gitlens.gutterForegroundColor": "#bebebe",
		"gitlens.gutterUncommittedForegroundColor": "#00bcf299",
		"gitlens.lineHighlightBackgroundColor": "#00bcf233",
		"gitlens.lineHighlightOverviewRulerColor": "#00bcf299",
		"gitlens.trailingLineBackgroundColor": "#00000000",
		"gitlens.trailingLineForegroundColor": "#99999959",
		"gitlens.viewChangesToPullIconColor": "#b15e35",
		"gitlens.viewChangesToPushIconColor": "#35b15e",
		"gitlens.viewCommitToPushIconColor": "#35b15e",
		"icon.foreground": "#c5c5c5",
		"imagePreview.border": "#80808059",
		"input.background": "#3c3c3c",
		"input.foreground": "#cccccc",
		"inputOption.activeBackground": "#007fd466",
		"inputOption.activeBorder": "#007acc00",
		"inputOption.activeForeground": "#ffffff",
		"inputValidation.errorBackground": "#5a1d1d",
		"inputValidation.errorBorder": "#be1100",
		"inputValidation.infoBackground": "#063b49",
		"inputValidation.infoBorder": "#007acc",
		"inputValidation.warningBackground": "#352a05",
		"inputValidation.warningBorder": "#b89500",
		"list.activeSelectionBackground": "#094771",
		"list.activeSelectionForeground": "#ffffff",
		"list.deemphasizedForeground": "#8c8c8c",
		"list.errorForeground": "#f88070",
		"list.filterMatchBackground": "#ea5c0055",
		"list.focusBackground": "#062f4a",
		"list.highlightForeground": "#0097fb",
		"list.hoverBackground": "#2a2d2e",
		"list.inactiveSelectionBackground": "#37373d",
		"list.invalidItemForeground": "#b89500",
		"list.warningForeground": "#cca700",
		"listFilterWidget.background": "#653723",
		"listFilterWidget.noMatchesOutline": "#be1100",
		"listFilterWidget.outline": "#00000000",
		"menu.selectionBackground": "#094771",
		"menu.selectionForeground": "#ffffff",
		"menu.separatorBackground": "#bbbbbb",
		"menubar.selectionBackground": "#ffffff1a",
		"menubar.selectionForeground": "#cccccc",
		"merge.commonContentBackground": "#60606029",
		"merge.commonHeaderBackground": "#60606066",
		"merge.currentContentBackground": "#40c8ae33",
		"merge.currentHeaderBackground": "#40c8ae80",
		"merge.incomingContentBackground": "#40a6ff33",
		"merge.incomingHeaderBackground": "#40a6ff80",
		"minimap.errorHighlight": "#ff1212b3",
		"minimap.findMatchHighlight": "#d18616",
		"minimap.selectionHighlight": "#264f78",
		"minimap.warningHighlight": "#cca700",
		"minimapGutter.addedBackground": "#587c0c",
		"minimapGutter.deletedBackground": "#94151b",
		"minimapGutter.modifiedBackground": "#0c7d9d",
		"minimapSlider.activeBackground": "#bfbfbf33",
		"minimapSlider.background": "#79797933",
		"minimapSlider.hoverBackground": "#64646459",
		"notebook.cellBorderColor": "#37373d",
		"notebook.cellInsertionIndicator": "#007fd4",
		"notebook.cellStatusBarItemHoverBackground": "#ffffff26",
		"notebook.cellToolbarSeparator": "#80808059",
		"notebook.focusedCellBorder": "#007fd4",
		"notebook.focusedEditorBorder": "#007fd4",
		"notebook.focusedRowBorder": "#ffffff1f",
		"notebook.outputContainerBackgroundColor": "#37373d",
		"notebook.rowHoverBackground": "#80808012",
		"notebook.selectedCellBorder": "#37373d",
		"notebook.symbolHighlightBackground": "#ffffff0b",
		"notebookScrollbarSlider.activeBackground": "#bfbfbf66",
		"notebookScrollbarSlider.background": "#79797966",
		"notebookScrollbarSlider.hoverBackground": "#646464b3",
		"notebookStatusErrorIcon.foreground": "#f48771",
		"notebookStatusRunningIcon.foreground": "#cccccc",
		"notebookStatusSuccessIcon.foreground": "#89d185",
		"notificationCenterHeader.background": "#303031",
		"notificationLink.foreground": "#3794ff",
		"notifications.background": "#252526",
		"notifications.border": "#303031",
		"notifications.foreground": "#cccccc",
		"notificationsErrorIcon.foreground": "#f48771",
		"notificationsInfoIcon.foreground": "#75beff",
		"notificationsWarningIcon.foreground": "#cca700",
		"panel.background": "#1e1e1e",
		"panel.border": "#80808059",
		"panel.dropBorder": "#e7e7e7",
		"panelSection.border": "#80808059",
		"panelSection.dropBackground": "#53595d80",
		"panelSectionHeader.background": "#80808033",
		"panelTitle.activeBorder": "#e7e7e7",
		"panelTitle.activeForeground": "#e7e7e7",
		"panelTitle.inactiveForeground": "#e7e7e799",
		"peekView.border": "#007acc",
		"peekViewEditor.background": "#001f33",
		"peekViewEditor.matchHighlightBackground": "#ff8f0099",
		"peekViewEditorGutter.background": "#001f33",
		"peekViewResult.background": "#252526",
		"peekViewResult.fileForeground": "#ffffff",
		"peekViewResult.lineForeground": "#bbbbbb",
		"peekViewResult.matchHighlightBackground": "#ea5c004d",
		"peekViewResult.selectionBackground": "#3399ff33",
		"peekViewResult.selectionForeground": "#ffffff",
		"peekViewTitle.background": "#1e1e1e",
		"peekViewTitleDescription.foreground": "#ccccccb3",
		"peekViewTitleLabel.foreground": "#ffffff",
		"pickerGroup.border": "#3f3f46",
		"pickerGroup.foreground": "#3794ff",
		"problemsErrorIcon.foreground": "#f48771",
		"problemsInfoIcon.foreground": "#75beff",
		"problemsWarningIcon.foreground": "#cca700",
		"progressBar.background": "#0e70c0",
		"quickInput.background": "#252526",
		"quickInput.foreground": "#cccccc",
		"quickInputTitle.background": "#ffffff1b",
		"scm.providerBorder": "#454545",
		"scrollbar.shadow": "#000000",
		"scrollbarSlider.activeBackground": "#bfbfbf66",
		"scrollbarSlider.background": "#79797966",
		"scrollbarSlider.hoverBackground": "#646464b3",
		"searchEditor.findMatchBackground": "#ea5c0038",
		"settings.checkboxBackground": "#3c3c3c",
		"settings.checkboxBorder": "#3c3c3c",
		"settings.checkboxForeground": "#f0f0f0",
		"settings.dropdownBackground": "#3c3c3c",
		"settings.dropdownBorder": "#3c3c3c",
		"settings.dropdownForeground": "#f0f0f0",
		"settings.dropdownListBorder": "#454545",
		"settings.focusedRowBackground": "#80808024",
		"settings.headerForeground": "#e7e7e7",
		"settings.modifiedItemIndicator": "#0c7d9d",
		"settings.numberInputBackground": "#3c3c3c",
		"settings.numberInputForeground": "#cccccc",
		"settings.textInputBackground": "#3c3c3c",
		"settings.textInputForeground": "#cccccc",
		"sideBar.background": "#252526",
		"sideBar.dropBackground": "#53595d80",
		"statusBar.background": "#007acc",
		"statusBar.debuggingBackground": "#cc6633",
		"statusBar.debuggingForeground": "#ffffff",
		"statusBar.foreground": "#ffffff",
		"statusBar.noFolderBackground": "#68217a",
		"statusBar.noFolderForeground": "#ffffff",
		"statusBarItem.activeBackground": "#ffffff2e",
		"statusBarItem.errorBackground": "#c72e0f",
		"statusBarItem.errorForeground": "#ffffff",
		"statusBarItem.hoverBackground": "#ffffff1f",
		"statusBarItem.prominentBackground": "#00000080",
		"statusBarItem.prominentForeground": "#ffffff",
		"statusBarItem.prominentHoverBackground": "#0000004d",
		"symbolIcon.arrayForeground": "#cccccc",
		"symbolIcon.booleanForeground": "#cccccc",
		"symbolIcon.classForeground": "#ee9d28",
		"symbolIcon.colorForeground": "#cccccc",
		"symbolIcon.constantForeground": "#cccccc",
		"symbolIcon.constructorForeground": "#b180d7",
		"symbolIcon.enumeratorForeground": "#ee9d28",
		"symbolIcon.enumeratorMemberForeground": "#75beff",
		"symbolIcon.eventForeground": "#ee9d28",
		"symbolIcon.fieldForeground": "#75beff",
		"symbolIcon.fileForeground": "#cccccc",
		"symbolIcon.folderForeground": "#cccccc",
		"symbolIcon.functionForeground": "#b180d7",
		"symbolIcon.interfaceForeground": "#75beff",
		"symbolIcon.keyForeground": "#cccccc",
		"symbolIcon.keywordForeground": "#cccccc",
		"symbolIcon.methodForeground": "#b180d7",
		"symbolIcon.moduleForeground": "#cccccc",
		"symbolIcon.namespaceForeground": "#cccccc",
		"symbolIcon.nullForeground": "#cccccc",
		"symbolIcon.numberForeground": "#cccccc",
		"symbolIcon.objectForeground": "#cccccc",
		"symbolIcon.operatorForeground": "#cccccc",
		"symbolIcon.packageForeground": "#cccccc",
		"symbolIcon.propertyForeground": "#cccccc",
		"symbolIcon.referenceForeground": "#cccccc",
		"symbolIcon.snippetForeground": "#cccccc",
		"symbolIcon.stringForeground": "#cccccc",
		"symbolIcon.structForeground": "#cccccc",
		"symbolIcon.textForeground": "#cccccc",
		"symbolIcon.typeParameterForeground": "#cccccc",
		"symbolIcon.unitForeground": "#cccccc",
		"symbolIcon.variableForeground": "#75beff",
		"tab.activeBackground": "#1e1e1e",
		"tab.activeForeground": "#ffffff",
		"tab.activeModifiedBorder": "#3399cc",
		"tab.border": "#252526",
		"tab.inactiveBackground": "#2d2d2d",
		"tab.inactiveForeground": "#ffffff80",
		"tab.inactiveModifiedBorder": "#3399cc80",
		"tab.unfocusedActiveBackground": "#1e1e1e",
		"tab.unfocusedActiveForeground": "#ffffff80",
		"tab.unfocusedActiveModifiedBorder": "#3399cc80",
		"tab.unfocusedInactiveBackground": "#2d2d2d",
		"tab.unfocusedInactiveForeground": "#ffffff40",
		"tab.unfocusedInactiveModifiedBorder": "#3399cc40",
		"terminal.ansiBlack": "#000000",
		"terminal.ansiBlue": "#2472c8",
		"terminal.ansiBrightBlack": "#666666",
		"terminal.ansiBrightBlue": "#3b8eea",
		"terminal.ansiBrightCyan": "#29b8db",
		"terminal.ansiBrightGreen": "#23d18b",
		"terminal.ansiBrightMagenta": "#d670d6",
		"terminal.ansiBrightRed": "#f14c4c",
		"terminal.ansiBrightWhite": "#e5e5e5",
		"terminal.ansiBrightYellow": "#f5f543",
		"terminal.ansiCyan": "#11a8cd",
		"terminal.ansiGreen": "#0dbc79",
		"terminal.ansiMagenta": "#bc3fbc",
		"terminal.ansiRed": "#cd3131",
		"terminal.ansiWhite": "#e5e5e5",
		"terminal.ansiYellow": "#e5e510",
		"terminal.border": "#80808059",
		"terminal.foreground": "#cccccc",
		"terminal.selectionBackground": "#ffffff40",
		"textBlockQuote.background": "#7f7f7f1a",
		"textBlockQuote.border": "#007acc80",
		"textCodeBlock.background": "#0a0a0a66",
		"textLink.activeForeground": "#3794ff",
		"textLink.foreground": "#3794ff",
		"textPreformat.foreground": "#d7ba7d",
		"textSeparator.foreground": "#ffffff2e",
		"titleBar.activeBackground": "#3c3c3c",
		"titleBar.activeForeground": "#cccccc",
		"titleBar.inactiveBackground": "#3c3c3c99",
		"titleBar.inactiveForeground": "#cccccc99",
		"tree.indentGuidesStroke": "#585858",
		"widget.shadow": "#0000005c"
	}
}

export default vsDarkTheme;
